import { Button } from '@ui/kit';
import { Chevron } from '@utils/react';
import { jsx } from 'react/jsx-runtime';

function NextButton(props) {
  return /*#__PURE__*/jsx(Button, {
    className: props.className,
    theme: props.theme,
    disabled: props.disabled,
    onClick: props.onClick,
    icon: props.disableIcon ? undefined : {
      position: "after",
      content: /*#__PURE__*/jsx(Chevron, {
        size: 8,
        lineWidth: 1.5
      })
    },
    tooltip: props.tooltip,
    children: props.label
  });
}

export { NextButton };
//# sourceMappingURL=button.next.js.map
